// Shared helpers for Sensaphone overview / specification tables (type + text columns).

/** Turn literal "\\n" from CMS into real newlines; keep natural newlines. */
export const normalizeNewlines = (s) => {
  if (typeof s !== "string" || !s) return s;
  return s.replace(/\\n/g, "\n");
};

/** After safeText(), normalize newlines for table cell display. */
export const cellTextForRow = (value, safeText) => {
  const raw = safeText(value);
  return normalizeNewlines(raw);
};
